import { Chip } from '@mantine/core';
import * as icons from '@sloyd/icons';
import { Wrapper } from './CellChip.style';

export type CellChipProps = {
  value: string;
  icon: string;
};

const names: any = {
  'asset-pack': 'Asset pack',
  scene: 'Scene',
  playground: 'Playground',
};

export function CellChip(props: CellChipProps) {
  const { value, icon } = props;

  function renderIcon() {
    const Cmp = (icons as any)[icon];
    if (!Cmp) return null;
    return <Cmp />;
  }

  const name = names[value] ?? 'unknown';

  return (
    <Wrapper className='CellChip-wrapper' data-testid='CellChip-wrapper'>
      <Chip color='pink' checked variant='light' size='xs' icon={renderIcon()}>
        &nbsp;{name}
      </Chip>
    </Wrapper>
  );
}

export default CellChip;
